module.exports = __webpack_public_path__ + "static/media/ils-loading.a390c441.svg";